import { useNavigate } from '@tanstack/react-router'

export const useAppNavigation = () => {
    const navigate = useNavigate()

    const goToInvoice = async (invoiceId: string) => {
        await navigate({ to: `/invoices/${invoiceId}` })
    }

    const goToReport = async (reportId: string) => {
        await navigate({ to: `/reporting/${reportId}` })
    }

    const goToEditReport = async (reportId: string) => {
        await navigate({ to: `/reporting/${reportId}/edit` })
    }

    return {
        goToInvoice,
        goToReport,
        goToEditReport,
    }
}
